import { render, staticRenderFns } from "./LmSignersBuilderUi.vue?vue&type=template&id=08f3f00a"
import script from "./LmSignersBuilderUi.vue?vue&type=script&lang=js"
export * from "./LmSignersBuilderUi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports